class Responsive {
    constructor() {
      var _this = this;
  
      this.currentBreakpoint = this.getCurrentBreakpoint();
  
      window.addEventListener("resize", function () {
        var newBreakpoint = _this.getCurrentBreakpoint();
  
        if (_this.currentBreakpoint === newBreakpoint) {
          return;
        }
  
        document.dispatchEvent(
          new CustomEvent("breakpoint:changed", {
            detail: {
              previousBreakpoint: _this.currentBreakpoint,
              currentBreakpoint: newBreakpoint,
            },
          })
        );
  
        _this.currentBreakpoint = newBreakpoint;
      });
    }
  
    matchesBreakpoint(breakpoint) {
      switch (breakpoint) {
        case "phone":
          return window.matchMedia("screen and (max-width: 640px)").matches;
  
        case "tablet":
          return window.matchMedia(
            "screen and (min-width: 641px) and (max-width: 1024px)"
          ).matches;
  
        case "tablet-and-up":
          return window.matchMedia("screen and (min-width: 768px").matches;
  
        case "pocket":
          return window.matchMedia("screen and (max-width: 1024px)").matches;
  
        case "lap-and-up":
          return window.matchMedia("screen and (min-width: 1025px)").matches;
  
        case "desk":
          return window.matchMedia("screen and (min-width: 1280px)").matches;
      }
    }
    getCurrentBreakpoint() {
      if (window.matchMedia("screen and (max-width: 640px)").matches) {
        return "phone";
      }
  
      if (
        window.matchMedia("screen and (min-width: 641px) and (max-width: 1024px)")
          .matches
      ) {
        return "tablet";
      }
  
      if (
        window.matchMedia(
          "screen and (min-width: 1008px) and (max-width: 1279px)"
        ).matches
      ) {
        return "lap";
      }
  
      if (window.matchMedia("screen and (min-width: 1280px)").matches) {
        return "desk";
      }
    }
  }

  // Video.js marks a player "playing" as soon as play() is called; with
  // preload "none" the first frame arrives later, so the placeholder image is
  // lifted only once a frame has actually been rendered, and in one step: a
  // fade would blend two pictures that do not line up.
  function hidePlaceholderOnFirstFrame(player, element) {
    var placeholder = element.querySelector(".videoHolder--Placeholder");
    // Video.js's own poster (the "poster" option) is hidden by its
    // vjs-has-started class at play(); keep it on the same terms.
    player.el().classList.add("vjs-keep-poster");
    var hide = function () {
      player.el().classList.remove("vjs-keep-poster");
      if (placeholder) { placeholder.classList.add("is-behind"); }
    };
    player.one("playing", function () {
      var video = player.el().querySelector("video");
      if (video && video.requestVideoFrameCallback) { video.requestVideoFrameCallback(hide); } else { hide(); }
    });
  }

  // Video.js play() returns a promise that rejects when a pause() lands before playback
  // starts (viewport enter/leave, the retry loop). That is expected here, not a failure.
  function tryPlay(player) {
    const p = player.play();
    if (p && typeof p.catch === "function") p.catch(function () {});
  }

class VideoComponents extends HTMLElement {
    constructor() {
      super();
      this.element = this;
  
      this.options = JSON.parse(
        this.element.getAttribute("data-section-settings")
      );

      this.trueObserver = false;
  
      if (this.options["using_fade"] == "fade") {
        if (
          this.element.dataset.position == 0 ||
          this.element
            .closest(".swiper-slide")
            .classList.contains("swiper-slide-active") ||
          this.element
            .closest(".swiper-slide")
            .classList.contains("swiper-slide-duplicate-active")
        ) {
  
          this.checkLoaded();
          this.bindEvents();
        } else {
          this.bindEvents();
        }
      } else {
  
        this.checkLoaded();
      }
    }
  
    bindEvents() {
      window.removeEventListener(
        "swiper:slide-changed",
        this.onSlideChangeListener
      );
      this.onSlideChangeListener = this.onSlideChange.bind(this);
      window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
    }
  
    // Only waits: the deferred CDN build in theme.liquid defines videojs.
    // Loading a second build here would create two player registries.
    checkLoaded() {
      var _this = this;
      if (typeof videojs !== "undefined") {
        this.videoPlayerInitialization();
      } else {
        setTimeout(function () {
          _this.checkLoaded();
        }, 100);
      }
    }
  
    onSlideChange(event) {
      this.elementPosition = parseInt(this.element.getAttribute("data-position"));
      if (event.detail.currentIndex == this.elementPosition) {
        if (!this.element.getAttribute("loaded")) {
          var node = document.createElement("div");
          node.appendChild(
            this.element
              .querySelector("template")
              .content.firstElementChild.cloneNode(true)
          );
          this.element.appendChild(node.firstElementChild).focus();
          this.element.setAttribute("loaded", true);
          if (!this.videoPlayer) {
            this.checkLoaded();
          } else {
            if (this.options["viewport"]) {
              tryPlay(this.videoPlayer);
              this.createObserver();
            }
          }
        } else {
          if (!this.videoPlayer) {
            this.checkLoaded();
          } else {
            if (this.options["viewport"]) {
              tryPlay(this.videoPlayer);
              this.createObserver();
            }
          }
        }
      } else if (
        this.videoPlayer &&
        this.videoPlayer.el_.classList.contains("vjs-playing")
      ) {
        this.videoPlayer.pause();
      }
    }
  
    videoPlayerInitialization() {
  
      if (!this.element.getAttribute("loaded")) {
  
        const node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
      }
  
      const responsive = new Responsive();
      const breakpoint = responsive.getCurrentBreakpoint();
      const isMobile = breakpoint === "phone" || breakpoint === "tablet";
  
      let aspect_ratio = "";
      let src = "";
      let host = "html5";
  
      if (isMobile) {
        aspect_ratio = this.options["aspect_mob"] || "9:16";
  
        if (this.options["videoType"] == "video_inside_media") {
          const sources = this.options["videod"]["sources"];
          let topQuality = null;
          sources.forEach((obj) => {
            if (obj.format === "mp4") {
              if (!topQuality) topQuality = obj;
              if (topQuality.height < obj.height) topQuality = obj;
            }
          });
          const aspectRatioHeight = Math.floor(
            100 / this.options["videod"]["aspect_ratio"]
          );
          if (!this.options["videoRatio"]) {
            aspect_ratio = `100:${aspectRatioHeight}`;
          } else {
            aspect_ratio = this.options["videoRatio"];
          }
          src = topQuality["url"] + "#t=0.001";
        } else if (this.options["videoType"] == "video_inside_media_external") {
          const aspectRatioHeight = Math.floor(
            100 / this.options["videom"]["aspect_ratio"]
          );
          if (!this.options["videoRatio"]) {
            aspect_ratio = `100:${aspectRatioHeight}`;
          } else {
            aspect_ratio = this.options["videoRatio"];
          }
          host = this.options["videom"]["host"];
          if (host == "youtube") {
            src =
              "https://www.youtube.com/watch?v=" +
              this.options["videom"]["external_id"];
          } else {
            src = this.options["videom"]["external_id"];
          }
        } else {
          if (this.options["videom"].includes("youtube")) {
            host = "youtube";
          } else if (this.options["videom"].includes("vimeo")) {
            host = "vimeo";
          }
          src = this.options["videom"];
        }
      } else {
        // A section that sets only the mobile ratio (rich-text video) shows
        // the same clip at every width; a 16:9 default there gives the poster a
        // different shape from the clip.
        aspect_ratio = this.options["aspect_desk"] || this.options["aspect_mob"] || "16:9";
        if (this.options["videoType"] == "video_inside_media") {
          const sources = this.options["videod"]["sources"];
          let topQuality = null;
          sources.forEach((obj) => {
            if (obj.format === "mp4") {
              if (!topQuality) topQuality = obj;
              if (topQuality.height < obj.height) topQuality = obj;
            }
          });
          src = topQuality["url"] + "#t=0.001";
          const aspectRatioHeight = Math.floor(
            100 / this.options["videod"]["aspect_ratio"]
          );
          if (!this.options["videoRatio"]) {
            aspect_ratio = `100:${aspectRatioHeight}`;
          } else {
            aspect_ratio = this.options["videoRatio"];
          }
        } else if (this.options["videoType"] == "video_inside_media_external") {
          host = this.options["videod"]["host"];
          const aspectRatioHeight = Math.floor(
            100 / this.options["videod"]["aspect_ratio"]
          );
          if (!this.options["videoRatio"]) {
            aspect_ratio = `100:${aspectRatioHeight}`;
          } else {
            aspect_ratio = this.options["videoRatio"];
          }
          if (host == "youtube") {
            src =
              "https://www.youtube.com/watch?v=" +
              this.options["videod"]["external_id"];
          } else {
            src = this.options["videod"]["external_id"];
          }
        } else {
          if (this.options["videod"].includes("youtube")) {
            host = "youtube";
          } else if (this.options["videod"].includes("vimeo")) {
            host = "vimeo";
          }
          src = this.options["videod"];
        }
      }
  
      if (!src) {
        src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
        host = "youtube";
      }
      const type =
        host === "youtube"
          ? "video/youtube"
          : host === "vimeo"
          ? "video/vimeo"
          : "video/mp4";
  
      aspect_ratio = aspect_ratio.replace("/", ":");
      const payload = {
        aspectRatio: aspect_ratio,
        autoplay: false,
        muted: this.options["muted"],
        loop: this.options["loop"],
        controls: this.options["controls"],
        poster: this.options["poster"] || false,
        // "none": these players sit below the fold and are started by the
        // IntersectionObserver; "metadata" makes Chrome fetch ~1 MB per clip on load.
        preload: "none",
        playsinline: true,
        responsive: true,
        techOrder: [host],
        disablePictureInPicture: true,
        controlBar: {
          children: [
            "playToggle",
            "progressControl",
            "currentTimeDisplay",
            "timeDivider",
            "durationDisplay",
            "CustomControlSpacer",
            "VolumePanel",
            "fullscreenToggle",
          ],
        },
  
        sources: [
          {
            type: type,
            src: src,
          },
        ],
      };
      this.host = host;
      // Size and show the holder now, so the placeholder image is on screen at
      // the clip's proportions before Video.js is ready, instead of a blank
      // that becomes a poster that becomes a video.
      const holder = this.element.querySelector(".videoHolder");
      if (holder) {
        holder.style.aspectRatio = aspect_ratio.replace(":", " / ");
        holder.style.display = "block";
      }
      const videoplayerID = this.element.querySelector("video");
      this.videoPlayer = videojs(videoplayerID, payload);
      hidePlaceholderOnFirstFrame(this.videoPlayer, this.element);
  
      const _this = this;
      this.videoPlayer.on("ready", function () {
        _this.element.querySelector(".videoHolder").style.display = "block";

        if (_this.trueObserver == false && _this.options["viewport"]) {
          _this.createObserver();
        }
      });
  
      if (this.options['muted'] && host == 'vimeo') {
        this.videoPlayer.on('play', function () {
  
          _this.videoPlayer.muted("true");
        })
      }
  
  
  
      if (this.options["controls"]) {
        if (host == 'html5'){
        this.videoPlayer.on("touchstart", function () {
          if (event.target.closest(".vjs-control-bar")) {
            return;
          }
    
          if (_this.videoPlayer.paused()) {
            tryPlay(_this.videoPlayer);
          } else {
            _this.videoPlayer.pause();
          }
        });}
        if(host == 'html5') return;
        this.videoPlayer.on("click", function () {
          if (event.target.closest(".vjs-control-bar")) {
            return;
          }
    
          if (_this.videoPlayer.paused()) {
            tryPlay(_this.videoPlayer);
          } else {
            _this.videoPlayer.pause();
          }
        });
      }
  
  
    }
  
    createObserver() {
      const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
        threshold: 0.5,
        rootMargin: "200px 0px 200px 0px",
      });
  
      observer.observe(this.element);
      this.trueObserver = true;
    }
  
    handleIntersect(entries) {
      entries.forEach((entry) => {
        if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
          if (!this.videoPlayer) {
            this.checkLoaded();
            return;
          }
  
          if (this.options["viewport"] && this.videoPlayer) {
          
            if(this.options['muted'] || this.host == 'vimeo' || this.host == 'youtube'){
              this.videoPlayer.muted("true");
            }
          
        
            const checkIfPlaying = () => {
            
              if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
                tryPlay(this.videoPlayer);
                setTimeout(checkIfPlaying, 100); // Wait 100 milliseconds and check again
              }
            };
  
            checkIfPlaying();
          }
        } else if (
          entry.intersectionRatio === 0 ||
          entry.isIntersecting == false
        ) {
          if (
            this.videoPlayer &&
            this.videoPlayer.el_.classList.contains("vjs-playing")
          ) {
            this.videoPlayer.pause();
          }
        }
      });
    }
  }
  customElements.define("video-components", VideoComponents);